import React, { useState, useEffect } from "react";
// @ts-ignore
import Carousel from 'react-grid-carousel'
import { NavLink } from "react-router-dom";
import Marquee from "react-fast-marquee";
import { motion } from "framer-motion";
import Navbar from "../../Navbar";
import image from "../../../img/award.jpeg";
import hands from "../../img/hands.png";
import volunteer from "../../img/volunteer.png";
import homemobile from "../../img/home-bg-mobile.svg";
import testbg from "../../img/test-bg.svg";
import bgbottom from "../../img/bottom.svg";
import Faq from "../../Faq";
import WFooter from "../../WFooter";
import Footer from "../../Footer";
import { SvgElement, icontypesEnum } from "../../assets/svgElement";


function AboutDetails() {

  const [open, setOpen] = useState(1);
  const [toggleText, setToggleText] = useState(1);

  const [openTestTab, setOpenTestTab] = useState(1);
  const [curImg, setCurImg] = useState(0);




  const handleOpen = (value: any) => {
    setOpen(open === value ? 0 : value);
  };

  const nextBtn = () => {
    var slider = document.getElementById("slider");

    slider!.scrollLeft = slider!.scrollLeft + 500;
  }
  const prevBtn = () => {
    var slider = document.getElementById("slider");


    slider!.scrollLeft = slider!.scrollLeft - 500;
  }



  return (
    <>
      <Navbar />
      {/* <!-- Start block --> */}
      <section className="bg-[#FBFBFB] body-font font-poppins md:pt-20 pt-[92px]">
        <div className="">
          <div
            style={{
              backgroundImage: `url(${image})`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              backgroundPosition: 'center center'

            }}
            className="md:pt-52 md:pb-8  flex justify-start "
          >
            <div className="py-20">
              <div className="text-[white] max-w-fit md:ml-44 pl-2 pr-20 flex justify-start mb-4 bg-black bg-opacity-80">
                <span className="font-[700] md:text-[20px] text-[20px] py-4" > Project Details</span>
              </div>

              <div className="text-[white] md:ml-44 pl-2 pr-20 flex justify-start bg-[#9F0000BA] bg-opacity-80">
                <span className="font-[700] md:text-[48px] text-[20px] py-4" > Community Appreciation Award: Honoring Mrs. Okunrinmeta Adenike as a Quintessential Amazon</span>
              </div>
            </div>
          </div>

          {/* <div className="bg-black py-4">
            <div className="grid md:grid-cols-2 md:px-20 px-3 gap-10 pt-10">
              <div className="text-white">
                Location : Pako Field, Pako B/Stp, Dopemu Lagos.
              </div>

              <div className="text-white">
                Topic : Talent Hunt
              </div>

              <div className="text-white">
                Objective : The center also work with young people to harness their talents and potentials in sports particularly football.
              </div>
            </div>
          </div> */}
        </div>
      </section>


      <section>
        <div className="pt-10 md:px-20 px-4 pb-5">
          <div className="text-[white] max-w-fit pl-2 pr-20 flex justify-start mb-10 bg-[#FA0000] ">
            <span className="font-[700] md:text-[20px] text-[20px] py-2" > Project Overview</span>
          </div>

          <p className="text-[#666666] text-[17px] font-[300] pb-5">Transformative impact is impossible to hide, just as good health should never be taken for granted. Today, the community of Olorunsogo-Olayemi-Ademokunla in Ogun State honours Youth Care Project (YCP) with a distinguished award for the quality healthcare delivered through the Clinic at Your Doorstep initiative.
          </p>

          <p className="text-[#666666] text-[17px] font-[300] pb-5">What began as a simple vision to close the gap between underserved communities and quality healthcare has grown into a lifeline for households that once had limited or no access to medical services.</p>

          <p className="text-[#666666] text-[17px] font-[300] pb-5">This award belongs to every community member who opened their doors to us, every stakeholder who believed in our mission, and every dedicated member of our team whose passion powers this work every day.</p>

          <p className="text-[#666666] text-[17px] font-[300] pb-5">For us at YCP, this recognition is not a finish line; it is a call to deepen our reach, expand our services, and continue building a healthcare system where proximity is no longer a barrier.
          </p>

          <p className="text-[#666666] text-[17px] font-[300] pb-5">To the Government and community leaders of Ogun State, thank you for recognising our efforts. Together, we will continue taking healthcare to the very doorsteps of those who need it most.
          </p>


        </div>
        {/* <div className="grid md:grid-cols-4 py-10 gap-2 px-10">
          <span>  <img src="/images/obafemiOwode/oo1.jpeg" alt="location" style={{}} /></span>
          <span>  <img src="/images/obafemiOwode/oo2.jpeg" alt="location" style={{}} /></span>
          <span>  <img src="/images/obafemiOwode/oo3.jpeg" alt="location" style={{}} /></span>
          <span>  <img src="/images/obafemiOwode/oo4.jpeg" alt="location" style={{}} /></span>

        </div> */}
      </section>

      <Footer />


      {/* <!-- End block --> */}

    </>
  );
}

export default AboutDetails;
